import React from 'react'
import { Grid, styled, Typography } from '@mui/material'
import { any, element } from 'prop-types'
import StyledDiv from './StyledDiv'

const StyledGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '0',
  /* background-color: blue; */

  flexWrap: 'wrap',
  background: theme.palette.leitura.main,
  color: 'white',
  borderRadius: '5px 5px 0 0',
  padding: '0.75rem 0.4rem',
  '& h5': {
    paddingLeft: '0.8rem'
  },

  '& .MuiInput-underline': {
    '&::before': {
      borderColor: 'white!important'
    }
  }
}))

// width: 100%;
//     background: rgb(255, 130, 0);
//     margin: 0.3rem;

const StyledTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    marginBottom: '0.5rem'
  },
  fontSize: '1.4rem'
}))
/* color: white; */

const TableHeader = ({ titulo, controls }) => {
  return (
    <StyledGrid className="test" item xs={12}>
      <div className="d-flex w-100 justify-space-between">
        <StyledTypography variant="h5">{titulo}</StyledTypography>
        <StyledDiv>{controls}</StyledDiv>
      </div>
    </StyledGrid>
  )
}
export default TableHeader

TableHeader.propTypes = {
  titulo: any,
  controls: element
}
